/** Minimal typed event bus to decouple engine ↔ ui without import cycles. */
export interface BusEvents {
  spotlight: string;      // open spotlight for camera id
  'wall:remove': string;  // remove camera id from the wall
  'wall:changed': void;   // wall composition/order changed -> re-render grid + panel
  'controls:sync': void;  // toolbar/control state should re-sync from state
  'cam:status': string;   // a camera's status changed -> update its panel dot
  'scan:stop': void;      // stop any running scan (e.g. user started a drag)
  'cam:deleted': string;  // a camera was deleted entirely -> close spotlight if showing it
  'view:changed': void;   // the view filter changed -> re-render wall, panel list, toolbar chip
}

type Handler<K extends keyof BusEvents> = (payload: BusEvents[K]) => void;
const map = new Map<keyof BusEvents, Set<Handler<never>>>();

export function on<K extends keyof BusEvents>(ev: K, fn: Handler<K>): void {
  let set = map.get(ev);
  if (!set) map.set(ev, (set = new Set()));
  set.add(fn as Handler<never>);
}

export function emit<K extends keyof BusEvents>(ev: K, payload: BusEvents[K]): void {
  map.get(ev)?.forEach((fn) => (fn as Handler<K>)(payload));
}
